// src/App.js
import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Import Layout and Page Components
import Layout from './components/Layout'; // Adjust path
import HomePage from './components/HomePage'; // Adjust path
import PictureDescriptionUI from './components/PictureDescriptionUI'; // Adjust path
import ProverbsExercise from './ProverbsExercise'; // Adjust path
import AuditoryComprehension from './components/AuditoryComprehension'; // Adjust path
// Import other demos if needed

// Import SettingsProvider
import { SettingsProvider } from './contexts/SettingsContext'; // Adjust path

function App() {
  return (
    <BrowserRouter>
      <SettingsProvider> {/* SettingsProvider wraps everything inside Router */}
        <Routes>
          {/* Use Layout component for routes that should have the sidebar */}
          <Route path="/" element={<Layout />}>
            {/* Index route for the landing page */}
            <Route index element={<HomePage />} />

            {/* Routes for your exercises */}
            <Route path="picture-description" element={<PictureDescriptionUI />} />
            <Route path="proverbs" element={<ProverbsExercise />} />
            <Route path="auditory-comprehension" element={<AuditoryComprehension />} />

            {/* Add routes for other demos here */}
            {/* <Route path="repetition" element={<RepetitionDemo />} /> */}
            {/* <Route path="reading-writing" element={<ReadingWritingDemo />} /> */}

            {/* Optional: Add a catch-all route for 404 */}
            <Route path="*" element={<div><h2>Page Not Found</h2></div>} />
          </Route>

          {/* You could have other routes here that DON'T use the Layout */}
          {/* <Route path="/login" element={<LoginPage />} /> */}

        </Routes>
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;